<div class="login-information">
  <div class="gl-page__header">
    <h1 class="gl-page__title">Login informatie</h1>
  </div>

  <p class="login-information__environment">Environment: {{ environmentName }}</p>

  @if (isLoading()) {
    <yds-spinner [label]="'Gegevens laden...'" />
  } @else {
    <yds-card>
      @if (isJwtTokenAvailable) {
          <div class="login-information__section">
            <h2 class="login-information__section-title">Jwt Token Decoded</h2>

            @if (decodedJwtToken(); as token) {
              <pre class="login-information__json">{{ token | json }}</pre>
            } @else {
              <p class="login-information__empty">Geen JWT-token beschikbaar (HTTP 401 of fout).</p>
            }
          </div>
      }

      <div class="login-information__section">
        <h2 class="login-information__section-title">Gebruikersinformatie<br>https://user.youforce.com/</h2>

        @if (userInfo(); as info) {
          <table class="login-information__table">
            <tbody>
              <tr>
                <th>Sub</th>
                <td>{{ info.sub }}</td>
              </tr>
              <tr>
                <th>Naam</th>
                <td>{{ info.name }}</td>
              </tr>
              <tr>
                <th>Voornaam</th>
                <td>{{ info.given_name }}</td>
              </tr>
              <tr>
                <th>Achternaam</th>
                <td>{{ info.family_name }}</td>
              </tr>
              <tr>
                <th>E-mail</th>
                <td>{{ info.email }}</td>
              </tr>
              <tr>
                <th>Taal</th>
                <td>{{ info.locale }}</td>
              </tr>
              <tr>
                <th>Bijgewerkt op</th>
                <td>{{ info.updated_at * 1000 | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
              </tr>
              <tr>
                <th>Tenant ID</th>
                <td>{{ info.tenant_id }}</td>
              </tr>
              <tr>
                <th>Profielfoto</th>
                <td>
                  <img
                    [src]="info.picture"
                    [alt]="info.name"
                    class="login-information__avatar"
                  />
                </td>
              </tr>
              <tr>
                <th>Gebruikersnaam</th>
                <td>{{ info.unique_name }}</td>
              </tr>
              <tr>
                <th>Bevoorrecht</th>
                <td>{{ info.is_privileged ? 'Ja' : 'Nee' }}</td>
              </tr>
            </tbody>
          </table>
        } @else {
          <p class="login-information__empty">Geen gebruikersinformatie beschikbaar (HTTP 401 of fout).</p>
        }
      </div>

      <hr class="login-information__divider" />

      <div class="login-information__section">
        <h2 class="login-information__section-title">Rechten (Entitlements)<br>https://iamapi.youforce.com/</h2>

        @if (entitlements()?.entitlements?.length) {
          <table class="login-information__table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Module ID</th>
              </tr>
            </thead>
            <tbody>
              @for (entitlement of entitlements()!.entitlements; track entitlement.id) {
                <tr>
                  <td>{{ entitlement.id }}</td>
                  <td>{{ entitlement.moduleId }}</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="login-information__empty">Geen rechten beschikbaar (HTTP 401 of fout).</p>
        }
      </div>
    </yds-card>
  }
</div>
